import ServerErrorPage from './ServerErrorPageContainer';

export default ServerErrorPage;
